import {
  FIRMWARE_FETCH_REQUEST,
  FIRMWARE_FETCH_REQUEST_SUCCESS,
  FIRMWARE_FETCH_REQUEST_FAILURE,
  FIRMWARE_ADD_REQUEST,
  FIRMWARE_ADD_REQUEST_SUCCESS,
  FIRMWARE_ADD_REQUEST_FAILURE,
  FIRMWARE_UPDATE_REQUEST,
  FIRMWARE_UPDATE_REQUEST_SUCCESS,
  FIRMWARE_UPDATE_REQUEST_FAILURE,
  FIRMWARE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const firmwaresReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case FIRMWARE_FETCH_REQUEST:
    case FIRMWARE_ADD_REQUEST:
    case FIRMWARE_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case FIRMWARE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case FIRMWARE_ADD_REQUEST_SUCCESS:
    case FIRMWARE_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case FIRMWARE_FETCH_REQUEST_FAILURE:
    case FIRMWARE_ADD_REQUEST_FAILURE:
    case FIRMWARE_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case FIRMWARE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default firmwaresReducer;
